// src/features/engine/tasks/osrboi/components/OSRBOIFeedback.js

import OSRBOIGraph from './OSRBOIGraph';
import Table from '../../../../../components/tables/Table';
import useOSRBOITranslator from '../hooks/useOSRBOITranslator';

const OSRBOIFeedback = ({ attributeData, onNext, isLastSample }) => {
  const t = useOSRBOITranslator();

  const userComment = attributeData?.overallImpression?.user || '-';
  const sharedComments = attributeData?.overallImpression?.shared || [];

  const commentData = [
    { source: t('your_evaluation'), comment: userComment },
    ...sharedComments.map((c, idx) => ({
      source: `${t('quebec_reference_rater')} ${idx + 1}`,
      comment: c
    }))
  ];

  return (
    <div className="feedback-section">

      <OSRBOIGraph
        attributeName="overallSeverity"
        userValues={attributeData?.overallSeverity?.userValues || []}
        sharedValues={attributeData?.overallSeverity?.sharedValues || []}
      />

      <OSRBOIGraph
        attributeName="roughness"
        userValues={attributeData?.roughness?.userValues || []}
        sharedValues={attributeData?.roughness?.sharedValues || []}
      />

      <OSRBOIGraph
        attributeName="breathiness"
        userValues={attributeData?.breathiness?.userValues || []}
        sharedValues={attributeData?.breathiness?.sharedValues || []}
      />

      <Table
        title={t('overall_impression')}
        data={commentData}
        columns={[
          { key: 'source', label: t('source') },
          { key: 'comment', label: t('comment') }
        ]}
      />

      <br/>

      <div className="app-btn-container">
        <button className="app-btn app-btn-primary" onClick={onNext}>
          {isLastSample ? t('finish_step') : t('next_sample')}
        </button>
      </div>

    </div>
  );
};

export default OSRBOIFeedback;
